import React from 'react';

interface Step2UrlProps {
  vintedUrl: string;
  searchText: string;
  onSearchTextChange: (text: string) => void;
  onUrlChange: (url: string) => void;
}

export const Step2Url: React.FC<Step2UrlProps> = ({
  vintedUrl,
  searchText,
  onSearchTextChange,
  onUrlChange
}) => {

  return (
    <div className="space-y-4">
      {/* Recherche rapide - n'affiche rien dans le champ URL */}
      <label className="block">
        <span className="text-lg font-semibold text-gray-800 mb-2 block">
          🔍 Recherche rapide
        </span>
        <input
          type="text"
          placeholder="Ex: Spiderman 2 PS5"
          value={searchText}
          onChange={(e) => onSearchTextChange(e.target.value)}
          className="w-full px-4 py-3 text-lg border-2 border-gray-300 rounded-xl focus:ring-2 focus:ring-cyan-500 focus:border-transparent"
        />
        <p className="text-sm text-gray-500 mt-1">
          Tapez votre recherche, l'URL sera générée automatiquement
        </p>
      </label>

      {/* Séparateur */}
      <div className="flex items-center gap-3">
        <div className="flex-1 h-px bg-gray-300"></div>
        <span className="text-sm text-gray-500 font-medium">OU</span>
        <div className="flex-1 h-px bg-gray-300"></div>
      </div>

      {/* URL manuelle - reste vide si recherche rapide, colle une URL → étape 5 */}
      <label className="block">
        <span className="text-lg font-semibold text-gray-800 mb-2 block">
          URL de recherche Vinted
        </span>
        <input
          type="text"
          value={vintedUrl}
          onChange={(e) => onUrlChange(e.target.value)}
          placeholder="Collez l'URL Vinted ici pour aller directement aux options"
          className="w-full px-4 py-3 text-lg border-2 border-gray-300 rounded-xl focus:ring-2 focus:ring-cyan-500 focus:border-transparent"
        />
      </label>

      {/* Info bulle */}
      <div className="bg-blue-50 border border-blue-200 rounded-xl p-4">
        <h4 className="font-semibold text-blue-900 mb-2">💡 Comment obtenir l'URL ?</h4>
        <ol className="text-sm text-blue-800 space-y-1 list-decimal list-inside">
          <li>Allez sur Vinted.fr</li>
          <li>Faites votre recherche avec tous les filtres souhaités (catégorie, état, tri, couleur...)</li>
          <li>Copiez l'URL complète de la page</li>
          <li>Collez-la ici</li>
        </ol>
      </div>
    </div>
  );
};
